import * as React from 'react';
import { Link } from 'react-router-dom';
import { JobVacancy } from '../../Model/JobVacancy';
import { UriBuilder } from '../../Service/UriBuilder';
import { AbstractItem, ItemProps } from './AbstractItem';

export class GroupItem extends AbstractItem {
    public render() {
        const props = this.props;
        const model = props.model;
        const className = 'job-center-list-item department-'
            + (model.department ? model.department.referenceId : '')
            + (model.highlight ? ' -highlight' : '');
        const uriBuilder = new UriBuilder();
        const referenceIdElement = <div className="reference-id">REF {model.referenceId}</div>;

        return <Link to={uriBuilder.uriForModel(model)} className={className}>
            <div className="row">
                <div className="col-sm-4 col-md-5 title">
                    {model.title}
                    {this.renderIndicator(props)}
                </div>
                <div className="col-sm-3 col-md-2 col-location">
                    {referenceIdElement}
                    <div className="location">{model.location}</div>
                </div>
                <div className="col-xs-2 hidden-sm col-md-2 col-reference-id">{referenceIdElement}</div>
                {this.renderSector(props, model)}
            </div>
        </Link>;
    }

    private renderSector(_props: ItemProps, model: JobVacancy) {
        const sector = model.sector;
        const sectorName = sector ? sector.name : undefined;
        const sectorColumnClass = 'small col-sector col-sm-5 col-md-3'
            + (!sector ? ' -empty' : '');

        const department = model.department;
        const departmentText = department && this.context.departmentId === ''
            ? <div>in {department.title}</div>
            : '';

        return <div className={sectorColumnClass}>
            <div className="sector">{sectorName}</div>
            {departmentText}
        </div>;
    }
}
